import Alt from 'alt';
var flux = new Alt();

module.exports = flux;



/** WEBPACK FOOTER **
 ** ./src/flux.js
 **/